import { useState, useEffect } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Single source of truth for the DISPLAYED price — reads the same value the
// backend charges (settings.price_paise via /api/config/public).
// Falls back to ₹2,999 if the config call fails (never blank / zero).
export default function usePriceLabel() {
    const [rupees, setRupees] = useState(2999);
    useEffect(() => {
        axios
            .get(`${API}/config/public`)
            .then(({ data }) => {
                if (data && typeof data.price_rupees === "number" && data.price_rupees > 0) {
                    setRupees(data.price_rupees);
                }
            })
            .catch(() => {
                /* keep ₹2,999 fallback */
            });
    }, []);
    return `₹${rupees.toLocaleString("en-IN")}`;
}
